import { PhaserUtils } from "../../../utils/PhaserUtils"

export enum MakeVaperPt1Audio {
    INTRO = "make-your-vaper-p1-n1.mp3",
    INSTRUCTIONS = "make-your-vaper-p1-n2.mp3",
    SMART = "make-your-vaper-p1-n3.mp3",
    COOL = "make-your-vaper-p1-n4.mp3",
    POPULAR = "make-your-vaper-p1-n5.mp3",
    EXCITING = "make-your-vaper-p1-n6.mp3",
    ATHLETIC = "make-your-vaper-p1-n7.mp3",
    REVIEW_VAPER = "make-your-vaper-p1-n8.mp3",
    FINISHED_VAPER = "make-your-vaper-p1-n9.mp3",
}

export function loadAssets(game: Phaser.Game) {
    const load = PhaserUtils.makeLoader(game, "make-vaper")
    load.autoLoad({audioEnum: MakeVaperPt1Audio})
}